import { render } from "./scrollButton.vue?vue&type=template&id=48f1ba4e"
import script from "./scrollButton.vue?vue&type=script&lang=js"
export * from "./scrollButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__